import React from 'react'
import './home.css'
import { Link } from 'react-router-dom'

const Home = () => {
  return (
    <section className='home'>
        <div className='homeContent flex'>
            <div className="textDiv">
                <span className="homeTitle">
                    Welcome to Hookup Room
                </span>
                <span className="smallText">
                    Your discreet sanctuary for unforgettable first encounters. Exclusive access, perfect amenities, and privacy guaranteed.
                </span>
            </div>
            <div className="buttons">
                <button className="book"><a href="https://t.me/BookHookupRoom">Book Now</a></button>  
                <button className="services"><a href='/services'>Services</a></button>
            </div>
                     
        </div>
    </section>
  )
}

export default Home